// @flow

export const EmptyAppStatsShape = {
  plain: {
    App: {
      Totals: {
        Total: 0,
        Live: 0,
        Paused: 0,
      },
    },
    Auth: {
      Users: {
        Total: 0,
        Live: 0,
        Paused: 0,
      },
      Accounts: {
        Total: 0,
        Live: 0,
        Paused: 0,
      },
    },
  },
  list: [
    {
      Type: 'App',
      Label: 'Totals',
      Total: 0,
      Live: 0,
      Paused: 0,
    },
  ],
};
